import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: Inter;
    font-style: normal;
    font-weight: 100 900;
    font-display: swap;
    src: url("/fonts/InterVariable.woff2") format("woff2");
  }
  * { box-sizing: border-box; }
  html { color-scheme: light; }
  body {
    margin: 0;
    font: ${p => p.theme.font};
    background: ${p => p.theme.color.bg};
    color: ${p => p.theme.color.ink};
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }
  button, input, textarea, select { font: inherit; }
  h1, h2 {
    letter-spacing: -0.03em;
    font-weight: 600;
  }
  h2 { font-size: 18px; margin: 26px 0 10px; }
  h2:first-child { margin-top: 0; }
  code {
    font-family: Consolas, "Cascadia Mono", monospace;
    font-size: 12.5px;
    background: ${p => p.theme.color.chipBg};
    padding: 1px 4px;
    border-radius: 4px;
  }
  input, select, textarea {
    font: inherit;
    padding: 8px 12px;
    border: 1px solid ${p => p.theme.color.inputBorder};
    border-radius: ${p => p.theme.radius.md};
    background: ${p => p.theme.color.card};
    color: ${p => p.theme.color.ink};
  }
  input:disabled, select:disabled, textarea:disabled {
    background: #F3F3EF;
    color: #5C564E;
    cursor: not-allowed;
  }
  input:focus, select:focus, textarea:focus {
    outline: 2px solid rgba(26, 26, 26, 0.16);
    border-color: ${p => p.theme.color.ink};
  }
  textarea { width: 100%; resize: vertical; }
  input[type="file"] { max-width: 100%; }
  a { color: ${p => p.theme.color.accentInk}; }
`;
